import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'error'
})
export class ErrorPipe implements PipeTransform {

  transform(value: string, ...args: any[]): string {
    if (_.isEqual(value, '1')) {
      return '';
    }
    return null;
  }

}
